export default {
  Asset: "Tài sản",
  Import: {
    Asset: "Tên Tài sản",
  },
  demoLayout: {
    code: "Mã nhân viên",
    name: "Tên nhân viên",
    org: "Phòng ban",
    gender: "Giới tính",
    dob: "Ngày sinh",
    inactive: "Ngừng theo dõi",
    salary: "Lương",
    created: "Ngày Tạo",
  },
  "asn": "ASN",
  "asn_organization": "Tổ chức cung cấp (ISP)",
  "tude": "Kinh độ : vĩ độ",
  "region": "Vùng",
  "registrar": "Thông tin đăng ký",
  "proxy": "Proxy",
  "city": "Thành phố",
  "country": "Quốc gia",
  "region": "region",
  domain: "Tên miền",
  hostnames: 'Máy chủ',
  domains: 'Tên miền',
  proxy_xoay: "Sử dụng proxy xoay",
  scanEngine: "Chỉ định cụm quét",
  scanEngineEmptyText: "Không chỉ định"
};
